export type FormattedDateProps = {
  dateOnly: string; // e.g. "2025-05-15"
  options?: Intl.DateTimeFormatOptions;
};

export function FormattedDate({
  dateOnly,
  options = { day: "2-digit", month: "2-digit", year: "numeric" },
}: Readonly<FormattedDateProps>) {
  // Validate the dateOnly format (YYYY-MM-DD)
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) {
    return <>—</>;
  }
  // Build a local-midnight Date
  const [y, m, d] = dateOnly.split("-").map(Number);
  const date = new Date(y, m - 1, d);

  return (
    <time dateTime={dateOnly}>
      {date.toLocaleDateString(undefined, options)}
    </time>
  );
}
